import api from '../../api/http-common'

// Survey

const getSurveys = (data?) =>
  api.post('/surveys/index', data)

const getSurveysList = () =>
  api.post('/surveys/list')

const countSurveys = () =>
  api.post('/surveys/count-active')

const getSurveysData = () =>
  api.post('/surveys/get-index-data')

const getSurveysCount = (data?) =>
  api.post('/surveys/count', data)

const getSurveyData = (id: string) =>
  api.post(`/surveys/${id}/edit`)

const planSurvey = (id: string) =>
  api.post(`/surveys/${id}/plan`)

const deleteSurvey = (id: string) =>
  api.post(`/surveys/${id}/delete`)

const shortPreviewSurvey = (id: string, data?) =>
  api.post(`/surveys/${id}/questions/preview`, data)

const surveyPdfExport = (id: string) =>
  api.post(`/surveys/${id}/questions/preview/pdf`)

const updateSurvey = (id: string, data) =>
  api.post(`/surveys/${id}/update`, data)

const recreateSurvey = (id: string, data) =>
  api.post(`/surveys/${id}/recreate`, data)

const farmersListSurvey = (id: string, data) =>
  api.post(`/surveys/${id}/farmers/index`, data)

const getFarmerAnswers = (idSurvey: string, idFarmer: string) =>
  api.post(`/surveys/${idSurvey}/farmers/${idFarmer}/get-answer`)

const createSurvey = (data) =>
  api.post('/surveys/store', data)

const getSurveyOptions = () =>
  api.post('/surveys/get-options-data')

// Show survey

const getSurveyShowData = (id: string) =>
  api.post(`/surveys/${id}/show`)

const getAllSurveys = (id: string) =>
  api.post(`/surveys/${id}/questions/import/get-surveys`)

const getSurveyQuestionList = (id: string) =>
  api.post(`/surveys/${id}/questions/import/get-questions`)

const importQuestionList = (id: string, data) =>
  api.post(`/surveys/${id}/questions/import`, data)

const getSurveyFarmerGroups = (id: string) =>
  api.post(`/surveys/${id}/statistics/farmer-groups/list`)

const getSurveyFarmerGroupsData = (id: string, data) =>
  api.post(`/surveys/${id}/farmer-groups/index`, data)

const getSurveyQuestionStatistics = (id: string, data) =>
  api.post(`/surveys/${id}/statistics/get-chart-data`, data)

const getSurveyQuestionStatisticsList = (id: string) =>
  api.post(`/surveys/${id}/statistics/questions/list`)

const getSurveyTableStatistics = (id: string, data) =>
  api.post(`/surveys/${id}/statistics/get-table-data`, data)

// Questions survey

const getSurveyQuestions = (id: string) =>
  api.post(`/surveys/${id}/get-questions`)

const createSurveyQuestions = (id: string, data?) =>
  api.post(`/surveys/${id}/questions/store`, data)

const getSurveyQuestionOptions = (id: string) =>
  api.post(`/surveys/${id}/questions/get-options-data`)

const sortSurveyQuestions = (id: string, data) =>
  api.post(`/surveys/${id}/questions/sort/store`, data)

const editSurveyQuestion = (id: string, idQuestion: string) =>
  api.post(`/surveys/${id}/questions/${idQuestion}/edit`)

const updateSurveyQuestion = (id: string, idQuestion: string, data) =>
  api.post(`/surveys/${id}/questions/${idQuestion}/update`, data)

const showSurveyQuestion = (id: string, idQuestion: string) =>
  api.post(`/surveys/${id}/questions/${idQuestion}/show`)

const deleteQuestion = (id: string, idQuestion: string) =>
  api.post(`/surveys/${id}/questions/${idQuestion}/delete`)

// Farmers

const getFarmerQuestions = (id: string, data?) =>
  api.post(`/surveys/${id}/answer/get-questions`, data)

const getNumberOfSurveyQuestions = (id: string) =>
  api.post(`/surveys/${id}/questions-count`)

const storeSurveyAnswers = (id, data) =>
  api.post(`/surveys/${id}/answer/store`, data)

const editSurveysQuestions = (id: string) =>
  api.post(`/surveys/${id}/answer/edit`)

const getSurveysQuestionsData = (id: string) =>
  api.post(`/surveys/${id}/answer/get-data`)

const checkIfAlreadyAnswered = (id: string) =>
  api.post(`/surveys/${id}/answer/check`)

const updateSurveysQuestions = (id: string, data) =>
  api.post(`/surveys/${id}/answer/update `, data)

const SurveyService = {
  getSurveys,
  getSurveysData,
  getSurveysCount,
  getSurveyData,
  createSurvey,
  updateSurvey,
  getSurveyOptions,
  getSurveyShowData,
  getSurveyQuestions,
  getSurveyQuestionOptions,
  createSurveyQuestions,
  sortSurveyQuestions,
  showSurveyQuestion,
  editSurveyQuestion,
  updateSurveyQuestion,
  deleteQuestion,
  deleteSurvey,
  planSurvey,
  shortPreviewSurvey,
  surveyPdfExport,
  getFarmerQuestions,
  countSurveys,
  storeSurveyAnswers,
  editSurveysQuestions,
  farmersListSurvey,
  getFarmerAnswers,
  recreateSurvey,
  getSurveyFarmerGroups,
  getSurveyQuestionStatistics,
  getSurveyTableStatistics,
  getNumberOfSurveyQuestions,
  getSurveyQuestionList,
  importQuestionList,
  getSurveyQuestionStatisticsList,
  getSurveysList,
  updateSurveysQuestions,
  getSurveyFarmerGroupsData,
  getAllSurveys,
  getSurveysQuestionsData,
  checkIfAlreadyAnswered
};

export default SurveyService;